const BROADCAST_CHANNEL = 'esan-paquetes-local-sqlite-v1';

export const LOCAL_SQLITE_PEER_UPDATE_EVENT = 'esan-local-sqlite-peer-update';

export function dispatchLocalSqlitePeerUpdate(): void {
  globalThis.dispatchEvent(new CustomEvent(LOCAL_SQLITE_PEER_UPDATE_EVENT));
}

export function onLocalSqlitePeerUpdate(handler: () => void): () => void {
  globalThis.addEventListener(LOCAL_SQLITE_PEER_UPDATE_EVENT, handler);
  return () => globalThis.removeEventListener(LOCAL_SQLITE_PEER_UPDATE_EVENT, handler);
}

let channel: BroadcastChannel | undefined;
let bound = false;

export function bindLocalSqlitePeerSync(onPeerPersist: () => Promise<void>): void {
  if (bound || typeof BroadcastChannel === 'undefined') return;
  channel = new BroadcastChannel(BROADCAST_CHANNEL);
  channel.onmessage = (ev: MessageEvent<{ type?: string }>) => {
    if (ev.data?.type !== 'persisted') return;
    void onPeerPersist().catch(() => {});
  };
  bound = true;
}

export function notifyLocalSqlitePeerTabs(): void {
  channel?.postMessage({ type: 'persisted', at: Date.now() });
}

export function resetLocalSqlitePeerSyncForTests(): void {
  channel?.close();
  channel = undefined;
  bound = false;
}

export function isLocalSqlitePeerSyncSupported(): boolean {
  return typeof BroadcastChannel !== 'undefined';
}
